var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.5001 15C23.8978 15 24.2793 15.1579 24.5605 15.4391C24.8418 15.7203 25 16.1017 25 16.4994C25 16.8972 24.8418 17.2785 24.5605 17.5598C24.2793 17.841 23.8978 17.9992 23.5001 17.9992H7.49963C7.10185 17.9992 6.72043 17.841 6.43916 17.5598C6.15788 17.2785 6 16.8972 6 16.4994C6 16.1017 6.15788 15.7203 6.43916 15.4391C6.72043 15.1579 7.10185 15 7.49963 15H23.5001Z"
  })));
};
export default SvgMinus;